import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { saveAs } from 'file-saver';
import './index.css';
import CommitEditor from './editor';
import { ajax } from 'jquery';

function getFormattedDate(date: string | undefined): string {
    if (date) {
        return date
    } else {
        const currentDate: Date = new Date();
        const year: number = currentDate.getFullYear();
        const month: number = currentDate.getMonth() + 1;
        const day: number = currentDate.getDate();
        const formattedMonth: string = month.toString().padStart(2, '0');
        const formattedDay: string = day.toString().padStart(2, '0');
        return `${year}-${formattedMonth}-${formattedDay}`;
    }
}

function replaceSpacesWithUnderscoresUsingReplaceAll(str: string): string {
    return str.replaceAll(' ', '_');
}

const Editor = () => {
    const noteRef = useRef<HTMLTextAreaElement>(null);
    const { date } = useParams()

    const [userData, setUserData] = useState<any>()
    const [noteData, setNoteData] = useState<any>()
    const [avatarToolShown, setAvatarToolShown] = useState<boolean>(false)
    const [editorToolShown, setEditorToolShown] = useState<boolean>(false)
    const [selectedBall, setSelectedBall] = useState<any>()
    const [selectedFace, setSelectedFace] = useState<number>(0)
    const [selectedDirection, setSelectedDirection] = useState<string>("")
    const [avatarData, setAvatarData] = useState<any>()
    const [comicData, setComicData] = useState<any>()
    const [forceRender, setForceRender] = useState<any>(false)
    const [isPublic, setIsPublic] = useState(0);

    const faceArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]
    const noteDate = getFormattedDate(date);

    useEffect(() => {
        const loadUserData = async () => {
            const result = await ajax({
                method: "GET",
                url: '/api/v1/countryball_card/user',
            })
            setUserData(result)
            setSelectedBall(result.activedCountries[0].name_en)
        }
        loadUserData()

        const loadNoteData = async () => {
            const result = await ajax({
                method: "GET",
                url: '/api/v1/countryball_card/note/' + noteDate,
            })
            if (result) {
                setNoteData(result)
                setSelectedBall(result.country)
                setSelectedFace(result.expressionType)
                setSelectedDirection(result.expressionOrientation)
                setAvatarData({
                    selectedBall: result.country,
                    selectedFace: result.expressionType,
                    selectedDirection: result.expressionOrientation
                })
                if (result.comic && result.comic !== '') {
                    setComicData(JSON.parse(result.comic))
                }
                setIsPublic(result.isPublic)
                noteRef.current!.value = result.note
            }
        }
        loadNoteData()
    }, [])

    const cancelAvatar = () => {
        setAvatarToolShown(false);
    }
    const ensureAvatar = () => {
        setAvatarData({
            selectedBall,
            selectedFace,
            selectedDirection
        })
        setAvatarToolShown(false);
    }

    const saveComic = (data: any) => {
        setForceRender(true)
        setComicData(data)
        setEditorToolShown(false);
        setForceRender(false)
    }

    const downoadComic = () => {
        const canvas = document.querySelector('canvas');
        canvas?.toBlob((blob) => {
            saveAs(blob!, 'countryball' + getFormattedDate(undefined) + '.jpg')
        })
    }

    const saveNote = async () => {
        const data = {
            country: selectedBall,
            note: noteRef.current!.value,
            expressionType: selectedFace,
            expressionOrientation: selectedDirection,
            comic: JSON.stringify(comicData),
            isPublic: isPublic,
            date: noteDate
        }
        try {
            const result = await ajax({
                method: "POST",
                url: '/api/v1/countryball_card/note',
                data
            })
            window.location.href = "/weeknotes"
        } catch (err) {
        }
    }


    const togglePublic = () => {
        setIsPublic(isPublic === 1 ? 0 : 1);
        const checkbox = document.querySelector('.checkbox') as HTMLInputElement;
        if (checkbox) {
            checkbox.checked = (isPublic === 1);
        }
    }

    return (
        <div className='page-wrap editor-page'>
            <div className="editor-page-content">
                <div className="editor-page-header">
                    <h3 className="editor-title">写日记 {noteDate}</h3>
                    <div className="switch-wrap">
                        <span className="switch-label" onClick={togglePublic}>公开日记</span>
                        <label className="switch">
                            <input type="checkbox" checked={isPublic === 1} className="checkbox" onClick={togglePublic} />
                        </label>
                    </div>
                </div>
                <div className="comic-box">
                    <div className="comic-canvas">
                        {
                            comicData &&
                            <CommitEditor
                                mode='view'
                                forceRender={forceRender}
                                comicData={comicData}
                            />
                        }
                    </div>
                    <div className="comic-btn">
                        <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2667" width="200" height="200"><path d="M629.76 194.56c-16.603429-14.409143-59.757714-26.697143-117.174857 9.435429-183.442286 115.565714-343.259429 324.022857-397.312 399.579428a54.857143 54.857143 0 0 1-89.234286-63.780571c54.857143-76.653714 225.133714-300.836571 428.105143-428.617143C541.988571 55.808 640 58.148571 701.732571 111.689143c30.793143 26.697143 50.029714 65.097143 50.322286 108.690286 0.292571 43.227429-17.993143 86.089143-51.346286 124.196571-104.374857 119.369143-242.249143 281.234286-300.178285 360.228571-7.606857 10.386286-8.118857 18.285714-7.460572 22.820572 0.731429 5.12 3.437714 9.947429 8.045715 13.385143 4.461714 3.291429 11.556571 6.070857 21.869714 4.900571 10.24-1.243429 26.331429-6.875429 45.933714-24.795428 16.530286-15.213714 33.718857-31.451429 51.419429-48.054858 54.491429-51.273143 113.371429-106.788571 172.324571-150.162285 61.293714-45.056 132.973714-57.563429 187.318857-24.356572 27.136 16.603429 46.226286 43.154286 52.882286 74.898286 6.582857 31.451429 0.292571 64.219429-15.579429 94.354286-16.969143 32.329143-31.744 55.588571-44.982857 76.507428l-1.024 1.682286a775.314286 775.314286 0 0 0-35.474285 59.904 37.010286 37.010286 0 0 0-1.755429 30.354286c1.755429 4.388571 3.437714 6.509714 4.388571 7.387428 6.729143 0.512 12.580571-1.170286 21.869715-8.338285 13.019429-10.166857 27.574857-27.355429 49.444571-56.027429a54.857143 54.857143 0 0 1 87.186286 66.633143c-20.845714 27.282286-43.446857 55.881143-69.339429 76.068571-28.672 22.235429-63.414857 35.766857-105.618285 30.208-46.299429-5.997714-76.653714-41.691429-90.038858-75.849143-14.043429-35.766857-14.701714-80.457143 6.582858-121.270857 13.897143-26.624 27.062857-47.323429 39.570285-66.998857l1.536-2.486857c12.946286-20.406857 25.746286-40.667429 40.594286-68.900571 6.217143-11.849143 5.632-18.651429 5.193143-20.772572a4.973714 4.973714 0 0 0-2.633143-3.730286c-3.145143-1.974857-25.380571-10.093714-65.097143 19.163429-53.101714 38.985143-104.813714 87.771429-157.988571 137.801143-18.651429 17.554286-37.522286 35.328-56.685715 52.882286-67.510857 61.878857-149.723429 70.144-207.579428 26.843428-56.32-42.130286-71.753143-122.88-23.405714-188.854857 61.220571-83.529143 202.386286-249.051429 306.102857-367.616 19.821714-22.674286 24.283429-40.594286 24.210285-51.346286a34.230857 34.230857 0 0 0-12.507428-26.477714z" fill="#000000" p-id="2668"></path></svg>
                        <span className="text" onClick={() => setEditorToolShown(true)}>{comicData ? "编辑" : "创建"}漫画</span>
                    </div>
                </div>
                <div className="textarea-box">
                    <div className="add-avatar-box" onClick={setAvatarToolShown.bind(this, true)}>
                        <div className="avatar-box">

                            {
                                avatarData !== undefined ?
                                    <div className="avatar-img ball-wrap">
                                        <img className='ball-pic' src={'https://oss.usecubes.cn/countryballs/new_balls/' + replaceSpacesWithUnderscoresUsingReplaceAll(avatarData.selectedBall) + '.png'} alt={avatarData.selectedBall} />
                                        <img className='face-pic' src={'https://oss.usecubes.cn/countryballs/faces/' + (avatarData.selectedFace + 1 + avatarData.selectedDirection) + '.png'} />
                                    </div>
                                    :
                                    <div className="avatar-placeholder">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="416" height="381" viewBox="0 0 416 381"><g><path d="M411,190.5C411,241.724,406.236,292.931,369.5,326.5C332.764,360.069,264.057,376,208,376C151.943,376,81.2358,355.569,44.5,322C7.7642299999999995,288.431,5,241.724,5,190.5C5,139.276,36.2642,89.0689,73,55.5C109.736,21.9311,151.943,5,208,5C264.057,5,311.764,21.9311,348.5,55.5C385.236,89.0689,411,139.276,411,190.5Z" fill="#FFFFFF" fill-opacity="1" /><path d="M398.04,114.228Q380.959,78.3879,351.873,51.809Q295.177,0,208,0Q165.61,0,131.476,12.98856Q98.2906,25.6164,69.6271,51.809Q39.3109,79.5118,20.8171,114.017Q0,152.858,0.000009999999999621423,190.5Q0.000009999999999621423,238.266,6.10904,264.025Q15.0917,301.9,41.1271,325.691Q68.6344,350.827,117.49,366.354Q163.577,381,208,381Q253.904,381,297.362,368.648Q345.879,354.858,372.873,330.191Q398.995,306.321,408.88,266.32Q416,237.509,416,190.5Q416,151.915,398.04,114.228ZM208,10Q291.296,10,345.127,59.191Q372.772,84.4528,389.012,118.53Q406,154.176,406,190.5Q406,236.292,399.172,263.921Q390.013,300.982,366.127,322.809Q340.875,345.884,294.628,359.029Q252.51,371,208,371Q165.128,371,120.519,356.823Q73.7576,341.962,47.8729,318.309Q24.1111,296.596,15.8391,261.717Q10.00001,237.096,10.00001,190.5Q10,155.369,29.631,118.741Q47.3177,85.7415,76.3729,59.1911Q103.629,34.2846,135.033,22.3348Q167.448,10,208,10Z" fill-rule="evenodd" fill="#000000" fill-opacity="1" /></g></svg>
                                        <span className="avatar-notice">点此添加<br />日记头像</span>
                                    </div>
                            }

                        </div>
                    </div>
                    <textarea rows={5} ref={noteRef} name="日记" id="note_text" placeholder='写下我的国家球日记吧！'></textarea>
                </div>
                <div className="add-new-note-box">
                    <a href="/weeknotes" className="common-btn">返回首页</a>
                    <a href="#" className="common-btn" onClick={() => { downoadComic() }}>下载漫画</a>
                    <a href="#" className="common-btn" onClick={() => { saveNote() }}>保存</a>
                </div>
                {
                    avatarToolShown &&
                    <div className="select-ball-avatar-wrap">
                        <div className="select-ball-avatar-content">
                            <div className="result-area">
                                {
                                    selectedBall && <div className='result-ball-box ball-wrap'>
                                        <img className='ball-pic' src={'https://oss.usecubes.cn/countryballs/new_balls/' + replaceSpacesWithUnderscoresUsingReplaceAll(selectedBall) + '.png'} alt={selectedBall} />
                                        <img className='face-pic' src={'https://oss.usecubes.cn/countryballs/faces/' + (selectedFace + 1 + selectedDirection) + '.png'} />
                                    </div>
                                }
                            </div>
                            <span className="select-notice">请选择国家球（<a href="/myballs" className="go-to-myballs">扫码添加更多国家</a>）</span>
                            <div className="select-ball-area">
                                {
                                    userData && userData.activedCountries.map((country: any, index: number) => {
                                        return <div className={'ball-wrap ' + (selectedBall.name === country.name ? "selected" : "")} key={index} onClick={setSelectedBall.bind(this, country.name_en)}>
                                            <img className='ball-pic' src={'https://oss.usecubes.cn/countryballs/new_balls/' + replaceSpacesWithUnderscoresUsingReplaceAll(country.name_en) + '.png'} alt={country.name_en} />
                                            <span className="ball-name">{country.name}</span>
                                        </div>
                                    })
                                }
                            </div>
                            <span className="select-notice">请选择表情</span>
                            <div className="select-face-area">
                                {
                                    faceArr.map((faceName, index) => {
                                        return <div className={'face-wrap ' + (selectedFace === index ? "selected" : "")} key={index} onClick={setSelectedFace.bind(this, index)}>
                                            <img className='face-pic' src={'https://oss.usecubes.cn/countryballs/faces/' + faceName + '.png'} />
                                        </div>
                                    })
                                }
                            </div>
                            <span className="select-notice">请选择表情方向</span>
                            <div className="select-direction-area">
                                <a href="#" className={"common-small-btn " + (selectedDirection === "_l" ? "selected" : "")} onClick={setSelectedDirection.bind(this, "_l")}>向左看</a>
                                <a href="#" className={"common-small-btn " + (selectedDirection === "" ? "selected" : "")} onClick={setSelectedDirection.bind(this, "")}>向前看</a>
                                <a href="#" className={"common-small-btn " + (selectedDirection === "_r" ? "selected" : "")} onClick={setSelectedDirection.bind(this, "_r")}>向右看</a>
                            </div>
                            <div className="selecte-ball-btn-box">
                                <a href="#" className="common-small-btn" onClick={cancelAvatar}>取消</a>
                                <a href="#" className="common-small-btn" onClick={ensureAvatar}>保存</a>
                            </div>
                        </div>
                    </div>
                }
                {
                    editorToolShown &&
                    <div className="select-ball-avatar-wrap">
                        <div className="select-ball-avatar-content">
                            <CommitEditor
                                mode='edit'
                                onCancel={() => setEditorToolShown(false)}
                                onSave={saveComic}
                                comicData={comicData}
                            />
                        </div>
                    </div>
                }
            </div>
        </div >
    );
}

export default Editor